import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'searchClienteDeudores'
})
export class SearchClienteDeudoresPipe implements PipeTransform {
    transform(value: any, args: any): any {
        if (!args || args === '') {
            return value;
        }
        return value.filter(item => -1 < item.nombre_completo.toString().toLowerCase().indexOf(args.toLowerCase()));

    }
}